import { PressableBrandAICard } from 'screens/BrandKits/components/BrandAICard/BrandAICard'
import Styles from './NewBrandAICard.module.scss'
import { PressEvent } from '@react-types/shared/src/events'
import cx from 'classnames'
import { BrandCardSize } from '../BrandAICard/Types'
import React, { FunctionComponent } from 'react'
import { observer } from 'mobx-react-lite'

interface Props {
  title: string
  upgradeBadge?: React.ReactNode
  onPress: (e: PressEvent) => void
  size?: BrandCardSize
  preview?: FunctionComponent<{ title: string; upgradeBadge?: React.ReactNode; size?: BrandCardSize }>
}

export const Plus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
    <path d="M4.51502 1.5V7.5M7.5 4.4831H1.5" stroke="var(--light-100)" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)

const DefaultPreview = ({
  title,
  upgradeBadge,
  size = 'sm',
}: {
  title: string
  upgradeBadge?: React.ReactNode
  size?: BrandCardSize
}) => (
  <div className={cx(Styles.preview, Styles[size])}>
    <div className={Styles.upgradeBadgeContainer}>{upgradeBadge}</div>
    <div className={Styles.plus}>
      <Plus />
    </div>
    <p className={Styles.text}>{title}</p>
  </div>
)

export const NewBrandAICard = observer(
  ({ title, onPress, size = 'sm', preview: Preview = DefaultPreview, upgradeBadge }: Props) => {
    return (
      <PressableBrandAICard
        size={size}
        preview={() => <Preview upgradeBadge={upgradeBadge} size={size} title={title} />}
        onPress={onPress}
      />
    )
  },
)
